import { MenuItemLink, MenuItemLinkProps } from "react-admin";
import React from "react";

interface ProtectedMenuItemLinkProps extends MenuItemLinkProps {
  permissions: any[];
  permissionResource: string;
  style?: any;
}

const ProtectedMenuItemLink: React.FC<ProtectedMenuItemLinkProps> = ({
  to,
  primaryText,
  leftIcon,
  permissions,
  permissionResource,
  style,
}) => {
  if (permissions.length === 0) {
    return <></>;
  }

  // give specific show menu access based on resource
  const findResource = permissions.includes(permissionResource);
  if (permissions && !findResource) {
    return <></>;
  }

  return (
    <MenuItemLink
      to={to}
      primaryText={primaryText}
      leftIcon={leftIcon}
      style={style}
    />
  );
};

export default React.memo(ProtectedMenuItemLink);
